/**
 * RECUPERE LES INFOS D'UN ETABLISSEMENT
 */
export const GET_ESTABLISHMENT = "establishment/GET_ESTABLISHMENT";
export const GET_ESTABLISHMENT_COMPLETED = "establishment/GET_ESTABLISHMENT_COMPLETED";
export const GET_ESTABLISHMENT_FAILED = "establishment/GET_ESTABLISHMENT_FAILED";
